exports = module.exports = require("./../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icons-view{padding:0 10px}.flex{display:-ms-flexbox;display:flex;margin-bottom:10px}.flex div{margin-left:20px}", "", {"version":3,"sources":["/./src/views/iconsView.vue"],"names":[],"mappings":"AACA,YAAY,cAAc,CACzB,AACD,MAAM,oBAAoB,aAAa,kBAAkB,CACxD,AACD,UAAU,gBAAgB,CACzB","file":"iconsView.vue","sourcesContent":["\n.icons-view{padding:0 10px\n}\n.flex{display:-ms-flexbox;display:flex;margin-bottom:10px\n}\n.flex div{margin-left:20px\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-0056e19a!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/views/iconsView.vue
// module id = 65
// module chunks = 0